import apiClient from "./axios"

export const getEmployees = async (params = {}) => {
  const { data } = await apiClient.get("/employees", { params })
  return data
}

export const getEmployee = async id => {
  const { data } = await apiClient.get(`/employees/${id}`)
  return data
}

export const createEmployee = async payload => {
  const { data } = await apiClient.post("/employees", payload)
  return data
}

export const editEmployee = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/employees/${id}`, payload)
  return data
}

export const deleteEmployee = async id => {
  const { data } = await apiClient.delete(`/employees/${id}`)
  return data
}

// System access (login) management

export const grantEmployeeAccess = async ({ id, ...payload }) => {
  const { data } = await apiClient.post(`/employees/${id}/grant-access`, payload)
  return data
}

export const revokeEmployeeAccess = async id => {
  const { data } = await apiClient.post(`/employees/${id}/revoke-access`)
  return data
}

export const updateEmployeeRoles = async ({ id, role_ids }) => {
  const { data } = await apiClient.put(`/employees/${id}/roles`, { role_ids })
  return data
}

export const resetEmployeePassword = async id => {
  const { data } = await apiClient.post(`/employees/${id}/reset-password`)
  return data
}

export const impersonateEmployee = async id => {
  const { data } = await apiClient.post(`/employees/${id}/impersonate`)
  return data
}
